import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "#environments/environment";
import { Injectable } from "@angular/core";
import { EquipmentType } from "#models/equipmentType.model";
import { Observable } from "rxjs";
import { shareReplay, tap } from "rxjs/operators";

@Injectable()
export class EquipmentTypeService {
  private _cache$: Observable<Array<EquipmentType>> | null = null;

  constructor(private http: HttpClient) {}

  get(): Observable<Array<EquipmentType>> {
    if (!this._cache$) {
      this._cache$ = this.http
        .get<Array<EquipmentType>>(`${environment.apiEndpoint}/equipment-types`)
        .pipe(shareReplay(1));
    }
    return this._cache$;
  }

  post(payload: any): Observable<EquipmentType> {
    return this.http
      .post<EquipmentType>(`${environment.apiEndpoint}/equipment-types`, payload)
      .pipe(tap(() => this.invalidateCache()));
  }

  put(payload: any): Observable<EquipmentType> {
    return this.http
      .put<EquipmentType>(
        `${environment.apiEndpoint}/equipment-types/${payload.ID}`,
        payload
      )
      .pipe(tap(() => this.invalidateCache()));
  }

  invalidateCache(): void {
    this._cache$ = null;
  }

  getByKeyword(keyword: string): Observable<EquipmentType[] | EquipmentType> {
    const params = {
      ...(keyword && { Keyword: keyword }),
    };

    return this.http.get<EquipmentType[] | EquipmentType>(
      `${environment.apiEndpoint}/equipment-types`,
      {
        params,
        headers: new HttpHeaders({
          "Cache-control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        }),
      }
    );
  }
}
